<template>
    <modal @close="closeModal" dusk="edit-server">
        <!--                    :error="form.errors.first('subscriptions.vps.0.subdomain')"-->
        <div class="field u-full-width">
            <div class="field u-full-width">
                <simple-text-input
                    v-model="vpsSubdomain"
                    :label="trans('order.vps-fields.subdomain')"
                    name="vpsSubdomain"
                    input-class="field__input field__input-vpssubdomain"
                    required
                />
            </div>
            <!--                    @input="setVpsSubdomain"-->
        </div>

        <div class="modal__nav">
            <button class="btn btn--ghost-gray btn-ghost--vps | u-margin-right" @click="closeModal">
                {{ trans('action.cancel') }}
            </button>
            <button class="btn btn--blue-record btn-ghost--vps" type="submit" @click="editServer">
                {{ trans('action.save') }}
            </button>
        </div>
    </modal>
</template>

<script>
import { EventBus } from 'relapp-event';
import { Modal } from 'relapp-modal';
import VpsApi from '../services/api/vps.js';
import {Way2Form} from "relapp-way2forms/src/way2forms";

export default {
    components: {
        Modal
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        server: Object
    },
    data() {
        return {
            vpsSubdomain: '',
            vps: this.server,
        };
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        },

        /**
         * Edit server
         */
        editServer() {
            VpsApi.updateSubdomain(this.domain, this.vps.data.id, new Way2Form({
                vpsSubdomain: this.vpsSubdomain + '.' + this.domain
            }))
                .then(() => {
                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.saved')
                    });
                })
                .catch(error => {
                    this.showError(error);
                });


            this.$emit('close');
            this.$parent.pollServerNameChange();
            this.$parent.targetName = this.vpsSubdomain + '.' + this.domain;
        }
    }
};
</script>
